import React from 'react';
import './MapEmbed.css';

const MapEmbed = () => {
  const address = 'BASAVANUGRHA BUILDING, 182/2+3a, Plot No-14, Vidya Nagar, Gokak 591307, Belgaum, Karnataka';
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;

  return (
    <section className="map-section section-padding">
      <div className="container">
        <div className="map-container fade-up">
          <iframe
            title="Contact Location Map"
            src={mapSrc}
            width="100%"
            height="500"
            style={{ border: 0, borderRadius: '12px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default MapEmbed;
